import awsConfig from './aws-exports';
import appConfig from './config';

export const getAmplifyConfig = () => {
  return {
    ...awsConfig,
    oauth: appConfig.oauth,
  };
};
